export enum BatchDocumentStatus {
  DONE = 'done',
  PROCESSING = 'processing',
  ERROR = 'error',
  NEW = 'new',
}
